import { css } from 'lit';

export const q1MemberChipStyles = css`

  :host {
    display: block;
  }

  item-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  item-wrapper.disabled {
    opacity: 0.4;
  }

  /*=== MEMBER NAME ===*/

  a.member-link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    --link-text-decoration-default: none;
    --link-color-default: var(--dm-gray-7, var(--gray-7));
    --link-color-visited: var(--dm-gray-7, var(--gray-7));
    --link-color-focus: var(--dm-gray-9, var(--gray-9));
  }

  .empty-member {
    font-style: italic;
    color: var(--dm-gray-6, var(--gray-6));
    font-weight: 300;
  }

  .member-name {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  sl-avatar {
    --size: 1.5rem;
  }

  /*=== ICON ===*/

  sl-icon {
    color: var(--icon-color, var(--dm-gray-6, var(--gray-6)));
  }

  /*=== EXTRA FIELDS ===*/
  
  .extra-field {
    color: var(--dm-gray-6, var(--gray-6));
    font-weight: 300;
  }
  
  /*=== SOCIAL LINKS ===*/

  sl-icon-button.linkedin-link {
    font-size: 1.2rem;
  }
  sl-icon-button.linkedin-link::part(base) {
    color: var(--dm-gray-5, var(--gray-5));
  }
  sl-icon-button.linkedin-link:hover::part(base),
  sl-icon-button.linkedin-link:focus::part(base) {
    color: var(--dm-gray-9, var(--gray-9));
  }

  item-spacer {
    display: inline-block;
    flex: 1 1 0;
  }

  /*=== LINKS BASE STYLE ===*/

  /* IMROVEME: Copied from view-styles. This should live in a reusable utility/helper. */
  a {
    color: var(--link-color-default, var(--blue-7));
    text-decoration: var(--link-text-decoration-default, underline);
    font-weight: var(--link-font-weight-default, normal);
    transition: all 0.2s ease-in-out;
  }
  a:visited {
    color: var(--link-color-visited, var(--blue-8));
  }
  a:focus, a:hover {
    color: var(--link-color-focus, var(--blue-9));
    font-weight: var(--link-font-weight-focus, var(--link-font-weight-default, normal));
    text-decoration: var(--link-text-decoration-focus, underline);
  }

`;
